import { combineReducers } from 'redux';
import { FlashMessage } from '@pegasus/ui-flashmessages';

import { fetchFlashMessages } from 'src/client/api/services/flashMessages';
import { defineFetchForNamespace } from 'src/client/components/shared/redux/fetch';

import { addClientFlashMessage, removeClientFlashMessage } from './actions';
import { getClientFlashMessages } from './selectors';
import { reducer as clientFlashMessageReducer } from './reducers';

export const NAME = 'fetch';
export const NAMESPACE = 'flashmessages';

const { reducer, getIsInitial, getIsLoading, getData, fetchData } = defineFetchForNamespace<
    FlashMessage[],
    void,
    typeof NAMESPACE,
    typeof NAME
>(NAMESPACE, NAME, () => fetchFlashMessages().then(response => response.results));

const getFlashMessagesReducer = () => ({
    [NAMESPACE]: combineReducers({
        [NAME]: reducer,
        view: clientFlashMessageReducer,
    }),
});

export {
    getFlashMessagesReducer,
    getIsInitial,
    getIsLoading,
    getData as getFlashMessages,
    fetchData as fetchFlashMessages,
    // custom getters / actions
    getClientFlashMessages,
    addClientFlashMessage,
    removeClientFlashMessage,
};
